import React, { memo } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { createBrowserHistory } from 'history';
import { reaction } from 'mobx';

import { pagesConfig } from './../../configs';
import { withCommon } from '../../components/';
import RenderRouterComponent from './render-routed-component';
import { LLLayout } from '../../layout';
import config from "../../static/themes/config";
import { resolveMeta } from '../utils';


const syncHistoryWithStore = (history, store) => {
    store._setHistory(history);

    function isLocationEqual(locationA, locationB) {
        return (
            locationA &&
            locationB &&
            locationA.key &&
            locationB.key &&
            locationA.key === locationB.key
        );
    }

    // Handle update from history object
    const handleLocationChange = (location) => {
        if (
            store?.location?.pathname &&
            store?.location?.pathname !== location.pathname
        ) {
            store._updatePreviousLocation(store.location);
        }
        store._updateLocation(location);
    };

    const unsubscribeFromHistory = history.listen(handleLocationChange);

    const unsubscribeFromStoreLocation = reaction(
        () => store.location,
        (location) => {
            if (!isLocationEqual(history.location, location)) {
                history.replace({ ...location });
            }
        }
    );

    history.unsubscribe = () => {
        unsubscribeFromHistory();
        unsubscribeFromStoreLocation();
    };

    store._updateLocation(history.location);

    return history;
};

let browserHistory = null;

const LLRouter = withCommon({
    store: ({ store }) => ({
        siteName: store.site.siteName,
        siteUrl: store.site.siteUrl,
        router: store.router,
        language: store.user.language,
    }),
    isTrans: true,
})(
    memo(({ siteName, siteUrl, router, language }) => {
        if (!browserHistory) {
            browserHistory = syncHistoryWithStore(createBrowserHistory(), router);
        }
        if (siteName === 'Casino' || !siteName) {
            siteName = config.siteName;
        }

        return (
            <Router history={browserHistory}>
                <LLLayout>
                    <Switch>
                        {Object.keys(pagesConfig()).map((page, i) => {
                            const { url, exact, meta, allowedForBlocked, ...restProps } = pagesConfig()[page];
                            const pageMeta = resolveMeta(meta, language);
                            return (
                                <Route path={url} exact={!!exact} key={i}>
                                    <Helmet htmlAttributes={{ lang: language }}>
                                        <title>{`${
                                            (siteName !== 'Amarobet' && siteName !== 'Betlima') ? 
                                                siteName + ' | '
                                                : ''
                                        }${pageMeta.title}`}</title>
                                        <meta
                                            name="description"
                                            content={pageMeta.description}
                                        />
                                        <link rel="canonical" href={siteUrl} />
                                    </Helmet>
                                    <RenderRouterComponent
                                        allowedForBlocked={allowedForBlocked}
                                        {...restProps}
                                    />
                                </Route>
                            );
                        })}
                    </Switch>
                </LLLayout>
            </Router>
        );
    })
);

export default LLRouter;
